'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOverlayTransition = undefined;

var _styledComponents = require('styled-components');

var _times = require('HubStyleTokens/times');

var overlayTransitionTime = parseInt(_times.MODAL_BACKGROUND_TRANSITION_TIMING, 10);

var getOverlayBackgroundColor = function getOverlayBackgroundColor(hidden) {
  return 'rgba(45, 62, 80, ' + (hidden ? '0' : '0.79') + ')';
};

var getOverlayTransition = exports.getOverlayTransition = function getOverlayTransition(dialogTransitionTime) {
  return (0, _styledComponents.css)(['.private-modal-dialog--overlay{transition-property:', ';transition-delay:', 'ms;transition-duration:', 'ms;background-color:', ';}'], function (_ref) {
    var transitioning = _ref.transitioning;
    return transitioning ? 'background-color' : 'none';
  }, function (_ref2) {
    var hidden = _ref2.hidden;
    return hidden ? dialogTransitionTime : 0;
  }, overlayTransitionTime, function (_ref3) {
    var hidden = _ref3.hidden;
    return getOverlayBackgroundColor(hidden);
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2644/js/dialog/internal/overlayTransitionMixin.js
// module id = 269
// module chunks = 3 4 5